import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-barra-superior',
    templateUrl: './barra-superior.component.html',
    styleUrls: ['./barra-superior.component.scss'],
    standalone: false
})
export class BarraSuperiorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
